import { modals } from '@mantine/modals';

import { useUpdateUserMutation } from '../store/users-api';
import { handleUserUpdateError } from '../utils/helpers/users-errors';
import { useShowResponseStatus } from '@/shared';

import type { TUpdateUserParams, TUser } from '../store/types';

export const useUpdateUser = () => {
  const [updateUser, { isLoading, isSuccess, error }] = useUpdateUserMutation();
  const updateError = handleUserUpdateError(error);

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Данные пользователя успешно обновлены',
    error: updateError,
  });

  const handleUserEdit = async (params: TUpdateUserParams) => {
    await updateUser(params);
  };

  const openEditModal = (item: TUser, elem: React.ReactNode) => modals.open({
    title: `Редактирование пользователя с ID ${item.id}`,
    centered: true,
    children: elem,
  });

  return {
    updateUser,
    handleUserEdit,
    openEditModal,
    isLoading,
  };
};
